import { func, oneOf } from 'prop-types';
import React, { Component } from 'react';

import { getTooltipButtonWithText } from '../../../generic/Tooltip';
import { campaignLineStatuses } from '../../constants';
import HELP_TEXTS from '../../utils/help-texts';

const { LOCKED, READY } = campaignLineStatuses;

const ButtonWithTooltip = getTooltipButtonWithText(HELP_TEXTS);
export default class ProductLockButton extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
    this.handleStatusChange = this.handleStatusChange.bind(this);
  }

  handleStatusChange() {
    const { onStatusChange } = this.props;
    this.setState({ isLoading: true }, () => {
      onStatusChange(LOCKED).finally(() => {
        this.setState({ isLoading: false });
      });
    });
  }

  render() {
    const { status } = this.props;
    const isDisabled = status !== READY;

    const { isLoading } = this.state;

    return (
      <ButtonWithTooltip
        size="sm"
        color=""
        className="c-campaign-line-btn btn-white-outline shadow"
        helpKey="productLock"
        section="actionButtons"
        disabled={isLoading || isDisabled}
        onClick={this.handleStatusChange}
        showTooltip={isLoading || isDisabled}
      >
        {isLoading ? 'Updating…' : 'Lock lines'}
      </ButtonWithTooltip>
    );
  }
}

ProductLockButton.propTypes = {
  status: oneOf(Object.values(campaignLineStatuses)).isRequired,
  onStatusChange: func.isRequired,
};
